var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0746 19.0748V15.9748H10.1746V5.64981H7.94961V8.8748H0.849609V0.924805H7.94961V4.0248H14.0746V0.924805H21.1496V8.8748H14.0746V5.64981H11.8246V14.3248H14.0746V11.0998H21.1496V19.0748H14.0746ZM2.49961 2.5498V7.2498V2.5498ZM15.7246 12.7498V17.4248V12.7498ZM15.7246 2.5498V7.2498V2.5498ZM15.7246 7.2498H19.4996V2.5498H15.7246V7.2498ZM15.7246 17.4248H19.4996V12.7498H15.7246V17.4248ZM2.49961 7.2498H6.32461V2.5498H2.49961V7.2498Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTree);
export default __webpack_public_path__ + "static/media/account_tree.08460add0c69682997fe6ba858b68b8d.svg";
export { ForwardRef as ReactComponent };